import type { PromptFilter, PromptStore, PromptTemplate, RenderedPrompt } from '../../ports/prompts'
import type { Transport } from './transport'

export class HttpPromptStore implements PromptStore {
  constructor(private readonly t: Transport) {}

  list(filter?: PromptFilter): Promise<PromptTemplate[]> {
    return this.t.json<PromptTemplate[]>('GET', '/v1/prompts', {
      query: {
        source: filter?.source,
        host: filter?.host,
        locale: filter?.locale,
        search: filter?.search,
      },
    })
  }

  get(id: string, version?: number): Promise<PromptTemplate> {
    return this.t.json<PromptTemplate>('GET', `/v1/prompts/${id}`, { query: { version } })
  }

  render(
    id: string,
    vars: Record<string, string>,
    opts?: { version?: number },
  ): Promise<RenderedPrompt> {
    return this.t.json<RenderedPrompt>('POST', `/v1/prompts/${id}/render`, {
      body: { vars, version: opts?.version },
    })
  }

  create(input: Omit<PromptTemplate, 'id' | 'version' | 'updatedAt'>): Promise<PromptTemplate> {
    return this.t.json<PromptTemplate>('POST', '/v1/prompts', { body: input })
  }

  update(id: string, patch: Partial<PromptTemplate>): Promise<PromptTemplate> {
    return this.t.json<PromptTemplate>('PATCH', `/v1/prompts/${id}`, { body: patch })
  }

  async delete(id: string): Promise<void> {
    await this.t.request('DELETE', `/v1/prompts/${id}`)
  }
}
